import React from "react";

const LoaderBox = ({...props}) => {

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "48px 24px",
            width: "100%",
        }}>
            <div style={{
                width: "40px",
                height: "40px",
                border: "3px solid #f0f0f0",
                borderTop: "3px solid #C2641A",
                borderRadius: "50%",
                animation: "loaderBoxSpin 0.8s linear infinite",
            }} />
            <style>{`@keyframes loaderBoxSpin { to { transform: rotate(360deg); } }`}</style>
            <div style={{
                fontSize: "0.95em",
                fontFamily: "'Open Sans', sans-serif",
                textAlign: "center",
                color: "#525f7f",
                marginTop: "16px",
            }}>
                {props.message ? props.message : "Carregando, aguarde..."}
            </div>
            {props.progress !== undefined && (
                <div style={{
                    width: '240px',
                    maxWidth: '100%',
                    backgroundColor: '#e9ecef',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    marginTop: '12px',
                    height: '6px',
                }}>
                    <div style={{
                        width: `${props.progress}%`,
                        height: '100%',
                        backgroundColor: '#C2641A',
                        transition: 'width 0.3s ease',
                        borderRadius: '4px',
                    }} />
                </div>
            )}
            {props.onCancel && (
                <button
                    onClick={props.onCancel}
                    style={{
                        marginTop: '16px',
                        padding: '6px 20px',
                        backgroundColor: 'transparent',
                        border: '1px solid #C2641A',
                        borderRadius: '4px',
                        color: '#C2641A',
                        cursor: 'pointer',
                        fontSize: '0.85em',
                        fontFamily: "'Open Sans', sans-serif",
                        transition: 'background-color 0.2s',
                    }}
                >
                    Cancelar
                </button>
            )}
        </div>
    );
}

export default LoaderBox;